import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _isEmpty from 'lodash/isEmpty';
import HeroContext from '../../PageContext';
import SecondCard from '../VariantB/SecondCard';
import MiddleCard from './MiddleCard';
import MiddlePolygons from './MiddlePolygons';
import LeftPolygons from './LeftPolygons';
import RightPolygons from './RightPolygons';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  appWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  firstColumn: {
    zIndex: 1,
    position: 'relative',
  },
  mb0: {
    zIndex: 1,
    '& a > div': {
      marginBottom: '0px !important',
    },
  },
  z99: {
    zIndex: 1,
  },
}));

function FeaturedResources() {
  const { clientInfo, featuredResources, sendMixpanelEvent } = useContext(
    HeroContext,
  );
  const classes = useStyles();
  const data = featuredResources;
  const { heroGraphics } = clientInfo;
  if (_isEmpty(data)) return null;

  const clickHandler = (title, props) => {
    sendMixpanelEvent(title, props);
  };
  const [a, b, c, d, e, f, g, h] = data; // hardcode this for now
  const showGraphics = heroGraphics === 'Show';
  return (
    <Grid container spacing={2} justify="flex-end">
      <Grid item xs={12} sm={4} md={4} className={classes.firstColumn}>
        {showGraphics && <LeftPolygons />}
        <Grid container>
          <Grid item xs={12}>
            <SecondCard data={a} clickHandler={clickHandler} />
          </Grid>
          <Grid item xs={12}>
            <SecondCard data={b} clickHandler={clickHandler} />
          </Grid>
          <Grid item xs={12} className={classes.mb0}>
            <SecondCard data={c} clickHandler={clickHandler} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} md={3} className={classes.root}>
        {showGraphics && <MiddlePolygons />}
        <Grid container>
          <Grid item xs={12} className={classes.z99}>
            <MiddleCard data={d} clickHandler={clickHandler} />
          </Grid>
          <Grid item xs={12} className={classes.mb0}>
            <MiddleCard data={e} clickHandler={clickHandler} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4} md={4} className={classes.root}>
        {showGraphics && <RightPolygons />}
        <Grid container>
          <Grid item xs={12} className={classes.z99}>
            <SecondCard data={f} clickHandler={clickHandler} />
          </Grid>
          <Grid item xs={12} className={classes.z99}>
            <SecondCard data={g} clickHandler={clickHandler} />
          </Grid>
          <Grid item xs={12} className={classes.mb0}>
            <SecondCard data={h} clickHandler={clickHandler} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default FeaturedResources;
